import Dropdown from 'components/Dropdown';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  className?: string;
  customStyles?: any;
};

const languages = ['en', 'de', 'es', 'fr'];
const defaultLanguage = 'en';

const LanguageDropdown: React.FC<Props> = ({ className, customStyles }) => {
  const { t, i18n } = useTranslation();

  const options = languages.map((language) => ({
    value: language,
    image: `country/${language}.svg`,
    label: t(`language.${language}`),
  }));

  const onChangeHandler = (lng) => {
    i18n.changeLanguage(lng);
    // HACK: Refresh page to reload HOC Translations and <Trans components
    location.reload();
  };

  const initValue = options.find((option) => option.value === i18n.language)
    ? i18n.language
    : defaultLanguage;
  return (
    <div className={className}>
      <Dropdown
        initValue={initValue}
        options={options}
        onChange={(lng) => onChangeHandler(lng)}
        customStyles={customStyles}
      />
    </div>
  );
};

export default LanguageDropdown;
